import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { ApiService } from '@/apiConnection/ApiService';
import { Urls } from '@/apiConnection/urls';
import { CustomModalComponent } from '@/components/custom-modal/custom-modal.component';
import { CustomSelectComponent } from '@/components/custom-select/custom-select.component';
import { Utils } from '@/utils/utils';

@Component({
    selector: 'app-tablet-pairing-form',
    imports: [ReactiveFormsModule, CustomModalComponent, CustomSelectComponent],
    templateUrl: './tablet-pairing-form.component.html',
})
export class TabletPairingFormComponent implements OnDestroy {
    private _offices: any[] = [];
    @Input() set offices(value: any[]) {
        this._offices = value ?? [];
        // Con una sola oficina no hay nada que elegir: se preselecciona y el selector se oculta.
        if (this._offices.length === 1) {
            this.officeControl.setValue(this._offices[0].id);
        }
    }
    get offices(): any[] {
        return this._offices;
    }
    @Output() closeFunction = new EventEmitter<any>();
    @Output() acceptFunction = new EventEmitter<any>();

    officeControl = new FormControl<number | null>(null, [Validators.required]);
    generating = false;
    code: string | null = null;
    remainingSeconds = 0;

    private expiresAt: Date | null = null;
    private countdownTimer: ReturnType<typeof setInterval> | null = null;

    get remainingLabel(): string {
        const minutes = Math.floor(this.remainingSeconds / 60);
        const seconds = this.remainingSeconds % 60;
        return `${minutes}:${String(seconds).padStart(2, '0')}`;
    }

    constructor(private apiService: ApiService, private cdr: ChangeDetectorRef) { }

    ngOnDestroy(): void {
        this.stopCountdown();
    }

    generateCode(): void {
        if (!this.officeControl.valid || this.generating) {
            Utils.notification.alert('Selecciona una oficina');
            return;
        }

        this.generating = true;
        this.apiService.post(Urls.urls.tabletsPairingCode, { office_id: this.officeControl.value }).subscribe({
            next: (response: any) => {
                this.code = response.code;
                this.expiresAt = new Date(response.expires_at);
                this.generating = false;
                this.startCountdown();
                this.cdr.detectChanges();
            },
            error: (error: any) => {
                Utils.notification.alert(Utils.extractErrorMessage(error) || 'No se pudo generar el código');
                this.generating = false;
                this.cdr.detectChanges();
            },
        });
    }

    acceptFormFunction(): void {
        this.closeFormFunction();
    }

    closeFormFunction(): void {
        this.stopCountdown();
        this.closeFunction.emit();
    }

    private startCountdown(): void {
        this.updateRemaining();
        this.countdownTimer = setInterval(() => {
            this.updateRemaining();
            this.cdr.detectChanges();
        }, 1000);
    }

    private stopCountdown(): void {
        if (this.countdownTimer) {
            clearInterval(this.countdownTimer);
            this.countdownTimer = null;
        }
    }

    private updateRemaining(): void {
        if (!this.expiresAt) return;
        this.remainingSeconds = Math.max(0, Math.round((this.expiresAt.getTime() - Date.now()) / 1000));
    }
}
